import React from "react";
import { connect } from "react-redux";
import { defaultLanguage } from "../../../helper/utility";
import { language } from "../../../languageProvider/language/language";
import ReadMore from "../../common/ReadMore";

import GalleryModal from "./components/Gallery.modal";
import ListModal from "./components/List.modal";
import TitleModal from "./components/Title.modal";
import RecipePdfButton from "../../share/RecipePdfButton";

const HatChefBodyMobile = ({ data, title, icon, type, productInfo }) => {
  const galleryImages =
    data.img && data.img.length > 0 ? data.img : productInfo?.images;

  // Costruito localmente dai props: su mobile la modale ha un feed
  // scroll-based e otherProps.markerInfo in redux non viene aggiornato
  // cambiando sezione, quindi non possiamo affidarci a quello per sapere
  // se siamo nella tab Ricetta (causava la sparizione del tasto PDF).
  const recipeMarkerInfo = { type: "hat-chef", title, data };

  return (
    <>
      <div
        className="d-flex align-items-start justify-content-between mb-4 interactive-title"
        style={{ gap: "12px" }}
      >
        <div
          className="d-flex align-items-start"
          style={{ flex: 1, minWidth: 0, gap: "8px" }}
        >
          <span style={{ flexShrink: 0, lineHeight: 1 }}>{icon}</span>
          {title ? <TitleModal title={title} /> : <h6 className="mb-0">{type}</h6>}
        </div>
        <RecipePdfButton
          markerInfo={recipeMarkerInfo}
          productInfo={productInfo}
          compact
        />
      </div>
      <div
        className="col-12 col-lg-6 h-lg-100"
        style={{ position: "relative" }}
      >
        <GalleryModal minImg={false} gallery={galleryImages} />
      </div>

      <div className="col-12 col-lg-6">
        <div
          className="overflow-lg-scroll px-15"
          style={{ height: "calc(100vh - 332px)", overflowY: "auto" }}
        >
          <div className="row">
            <div className="col-12">
              <h6
                className="mb-3"
                style={{
                  fontWeight: "bold",
                  marginBottom: "5px",
                }}
              >
                {language[defaultLanguage].ingredienti}
              </h6>
              <ListModal list={data.ingredients} />
            </div>
          </div>

          <div className="row">
            <div className="h-100 col-12 mt-5">
              <h6
                className="mb-3"
                style={{
                  fontWeight: "bold",
                  marginBottom: "5px",
                }}
              >
                {language[defaultLanguage].procedimento}
              </h6>
              <ReadMore limit={9999}>{data.recipe}</ReadMore>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  // productInfo serve al PDF per il nome prodotto nell'header.
  // markerInfo è invece costruito localmente nel componente: vedi commento
  // a recipeMarkerInfo.
  productInfo: state.modal.otherProps?.info,
});

export default connect(mapStateToProps)(HatChefBodyMobile);
